<template>
  <div class="project">
    <TodoProjectHeader v-on:create-todo="createTodo" v-bind:project="project"/>
    <draggable class="todo-list">
      <ToDoItem v-on:delete-todo="deleteTodo(todo)" v-on:submit-todo="submitTodo(todo)" v-on:edit-todo="editTodo" v-on:complete-todo="completeTodo" v-for="todo in sortedTodos" v-bind:todo="todo" v-bind:key="todo.issueNo"></ToDoItem>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import ToDoItem from "@/components/ToDoItem.vue";
import TodoProjectHeader from "@/components/forms/FormAddTodo.vue";

export default {
  name: "ToDoList",
  props: ["project"],
  data() {
    return {
      isSorted: true
    };
  },
  components: {
    draggable,
    TodoProjectHeader,
    ToDoItem
  },
  methods: {
    completeTodo(todo) {
      const todoIndex = this.project.todos.indexOf(todo);
      this.project.todos[todoIndex].isDone = !this.project.todos[todoIndex]
        .isDone;
    },
    createTodo(newTodo) {
      this.project.todos.push(newTodo);
    },
    editTodo(todo) {
      this.project.todos.forEach(todo => (todo.isEditing = false));
      const todoIndex = this.project.todos.indexOf(todo);
      this.project.todos[todoIndex].isEditing = !this.project.todos[todoIndex]
        .isEditing;
    },
    submitTodo(todo) {
      const todoIndex = this.project.todos.indexOf(todo);
      this.project.todos[todoIndex].isEditing = false;
    },
    deleteTodo(todo) {
      const todoIndex = this.project.todos.indexOf(todo);
      this.project.todos.splice(todoIndex, 1);
    }
  },
  computed: {
    sortedTodos: function() {
      const sortedTodos = this.project.todos.slice().sort((a, b) => {
        return a.isDone === b.isDone ? 0 : a.isDone ? 1 : -1;
      });
      return sortedTodos;
    }
  }
};
</script>
<style lang="scss">
.project {
  @include container;
  &:not(:first-child) {
    opacity: 0.2;
  }
}
.todo-list {
  display: grid;
  list-style-type: none;
  &:empty {
    &:before {
      content: "There are no todos yet";
      opacity: 0.5;
    }
  }
}
</style>
